import {Edit, MoreVert} from "@mui/icons-material";
import {IconButton, Menu, MenuItem, Typography} from "@mui/material";
import React from "react";
import {Grey17, Grey6} from "../../theme/styles";
import css_self from "../Navigation/css/NavBar.module.scss";
import {EnlilTable} from "../EnlilTable";
import {withAppContext} from "../withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import EventBus from "../../util/EventBus";
import css_buttons from "../../components/Common/css/CCButton.module.scss";
import AdminWorkGroupPositionFormApplet from "../../eoec/applet/impl/Administration/AdminWorkGroupPositionFormApplet";

class AdminWorkGroupPositionTable extends EnlilTable {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("admin-work-group-position-form-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("admin-work-group-position-form-applet-save", this.onCancelHandler);
    }

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("admin-work-group-position-form-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("admin-work-group-position-form-applet-save", this.onCancelHandler);
    }

    getCellRenderer(name) {
        if (name === "Action Cell") {
            return this.renderActionCell;
        }
        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "New Position") {
            this.setState({renderTarget: "New Position"});
        } else if (identifier === "Disassociate Position") {
            this.setState({renderTarget: "Disassociate Position"});
        }
        super.handleMenuClick(identifier);
    }

    renderExtension() {
        if (this.state.renderTarget === "New Position") {
           return <AdminWorkGroupPositionFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} availableModes={["Edit", "New", "View"]} defaultMode="New" />;
        } else if (this.state.renderTarget === "Disassociate Position") {
           return <AdminWorkGroupPositionFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} availableModes={["Edit", "New", "View"]} defaultMode="Delete" />;
        }
    };

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderActionCell = (instance, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{width: "50px", backgroundColor: "#FFFFFF", marginLeft: "-10px"}}>
                <IconButton className={css_buttons.tableOptionButton} onClick={(event) => {
                    if (this.state.tableActionMenuTarget === null) {
                        this.setState({tableActionMenuTarget: event.currentTarget});
                    } else {
                        this.setState({tableActionMenuTarget: null});
                    }
                }}>
                    <MoreVert />
                </IconButton>
                <Menu anchorEl={this.state.tableActionMenuTarget}
                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                      transformOrigin={{vertical: -10, horizontal: "center"}}
                      open={this.state.tableActionMenuTarget !== null && this.state.tableActionMenuTarget !== undefined}
                      onClose={() => this.setState({tableActionMenuTarget: null})}
                      TransitionProps={{
                          onExited: () => this.setState({tableActionMenuTarget: null}),
                      }}
                      MenuListProps={{
                          ...{"data-cc-component": "NavMenu"},
                          disablePadding: true,
                          style: {"minWidth": "200px"},
                      }}
                      PaperProps={{
                          elevation: 2,
                      }}
                >
                    <MenuItem divider key={"1"} className={css_self.Standard} onClick={() => {
                        this.setState({tableActionMenuTarget: null, renderTarget: "Disassociate Position"});
                    }}>
                        <Edit style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Disassociate Position</Typography>
                    </MenuItem>
                </Menu>
            </div>
        );
    };
}

export default withNavigate(withAppContext(withBreakpoint(AdminWorkGroupPositionTable)));